import React from 'react';
import styled, { css } from 'styled-components';
import { v4 as uuid } from 'uuid';
import { mediaQuery } from '@99designs/emu/css';
import { AccordionItemLegacy } from '../AccordionItemLegacy';
import type { AccordionIconType } from '../AccordionItemLegacy';

export interface QuestionAnswerProps {
    id?: string;
    question: string;
    answer: React.ReactNode;
}

interface FAQProps {
    faqs: QuestionAnswerProps[];
    isFirstColumn?: boolean;
    onOpen?: (faq: QuestionAnswerProps) => void;
    iconType?: AccordionIconType;
}

const StyledAccordionItem = styled(AccordionItemLegacy)<{ hideBottomBorder: boolean }>(
    ({ hideBottomBorder }) => {
        if (hideBottomBorder) {
            return css`
                ${mediaQuery.maximum('medium')} {
                    border-bottom-width: 0 !important;
                }
            `;
        } else {
            return css``;
        }
    }
);

export function FAQs({ faqs, isFirstColumn = false, onOpen, iconType }: FAQProps) {
    return (
        <>
            {faqs.map((faq, index) => {
                const { answer, question } = faq;
                const isLastItem = faqs.length - 1 === index;

                return (
                    <StyledAccordionItem
                        key={index}
                        itemKey={uuid()}
                        title={question}
                        hideBottomBorder={isFirstColumn && isLastItem}
                        onOpen={() => onOpen && onOpen(faq)}
                        iconType={iconType}
                    >
                        {answer}
                    </StyledAccordionItem>
                );
            })}
        </>
    );
}
